export const GET_PAGE_FONTS = 'GET_PAGE_FONTS';
export const ADD_FETCHED_FONTS = 'ADD_FETCHED_FONTS';
export const GET_FONTS_REGISTRY = 'GET_FONTS_REGISTRY';
export const FETCHING_FONTS = 'FETCHING_FONTS';
export const FETCHED_FONT_ERRORS = 'FETCHED_FONT_ERRORS';
